<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Welcome E-Mail"/>
      <div v-if="email" class="text-left">
        <mdb-input id="enable-checkbox" label="Welcome E-Mail Enabled" type="checkbox" v-model="email.sendWelcome"/>
        <editor v-if="email.sendWelcome" :init="editorConfig" v-model="email.welcomeMessage"/>
        <mdb-btn :disabled="email.sendWelcome && !email.welcomeMessage" icon="save" @click="doSave">Save</mdb-btn>
      </div>

    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import editor from '@tinymce/tinymce-vue'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'

import {mdbBtn, mdbContainer, mdbInput,} from 'mdbvue';

export default {
    name: "group-assistant",
    order: 1,
    components: {
      mdbContainer,
      mdbInput,
      mdbBtn,
      bannerSmall,
      editor
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup
                       }),
    data() {
      return {
        email: null,
        editorConfig: {
          browser_spellcheck: true,
          branding: false,
          plugins: ["image", "link", "code", "paste", "table", "lists"],
          toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | link unlink code "],
          style_formats_merge: true,
          paste_as_text: true,
          paste_data_images: false,
          relative_urls: false,
          remove_script_host: false,
          height: 400
        }
      }
    },
    mounted() {
      document.title = "Welcome E-Mail"
      this.$store.dispatch("setExecuting", true)
      api.get("/group/welcomeEmail/" + this.$route.params.id).then(
        (results) => {
          this.email = results.data
          if (!this.currentGroup || this.currentGroup.id != results.data.groupId) {
            api.groupBasics(results.data.groupId, "public");
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      doSave() {
        this.$store.dispatch("setExecuting", true)
        api.post("/group/welcomeEmail/" + this.$route.params.id,this.email).then(
          (results) => {
            this.$notify.success({message: "Saved.", timeOut: 3000})
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  };

</script>

